export const tabsLinks: Record<string, string> = {
    'BET SLIP': 'HOME_BETSLIP',
    'BET HISTORY': 'LOAD_BET_HISTORY',
    'CASH OUT': 'LOAD_CASHOUT_BETS',
    'MY BETS': 'LOAD_UNSETTLED_BETS',
};
